PJQ.views.settings = {};
PJQ.models.settings = {};
PJQ.collections.settings = {};

PJQ.modules.settings = {
    oldRoutes: [],
    routes: [
        {
            route: '?state=:state&code=:code',
            name: 'procoreRefer',
            retainParameterValueCase: true,
            callback: function (state, code) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'integration'
                        },
                        {
                            endpoint: 'procore'
                        },
                        {
                            endpoint: 'link'
                        }
                    ], [
                        {
                            parameter: 'userId',
                            value: PJQ.app.session.user.id
                        },
                        {
                            parameter: 'code',
                            value: code
                        }
                    ])
                }).post().done(function () {
                    PJQ.app.initNavigator({
                        activeItem: 'settings',
                        viewOptions: {
                            procoreCode: code
                        }
                    });
                });
            }
        },
        {
            route: "settings",
            name: 'settings',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings"
                });
            }
        },
        {
            route: "settings/billing",
            name: 'billingInfo',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: "billing"
                    },
                    preventTour: true
                });
            }
        },
        {
            route: 'settings/addressbook',
            name: 'addressBookSettings',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings"
                });
            }
        },
        {
            route: 'settings/account/:subscriptionId',
            name: 'settings',
            callback: function (subscriptionId) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        subscriptionId: parseInt(subscriptionId)
                    }
                });
            }
        },
        {
            route: 'settings/projects',
            name: 'projectSettings',
            callback: function () {
                PJQ.app.initNavigator({
                    activeItem: "settings"
                });
            }
        },
        {
            route: 'settings/:module',
            name: 'projectSettings',
            callback: function (module) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: module
                    }
                });
            }
        },
        {
            route: "settings/integrations/:name",
            name: 'integration',
            callback: function (name) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: "integrations",
                        integrationName: name
                    },
                    preventTour: true
                });
            }
        },
        {
            route: "settings/integrations/:name?authorized=:authorized",
            name: 'integrationAuth',
            callback: function (name, authorized) {
                PJQ.app.initNavigator({
                    activeItem: "settings",
                    viewOptions: {
                        initView: "integrations",
                        integrationName: name,
                        authorized: authorized === 'true'
                    },
                    preventTour: true
                });
            }
        },
    ]
};

PJQ.app.addOldRoutes(PJQ.modules.settings.oldRoutes);
PJQ.app.addRoutes(PJQ.modules.settings.routes);
